<template>
<div
    v-if="setup_data != null"
>

    <b>Integrations</b>

    <p
        style="margin-top: 15px"
    >
        Please select the integrations you plan to use below, <b><u>read and follow the associated directions to get started</u></b>
    </p>

    <v-checkbox
        label="Commerce7"  
        :value="isIntegrationOn('commerce7')" 
        v-on:change="setIntegration($event, 'commerce7')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('commerce7')"
    >
        <p>To connect Commerce7 and RedChirp, install the RedChirp Commerce7 app. Click <a href="https://redchirp.com/how-to-connect-redchirp-and-commerce7/" target="_blank">here</a> for instructions.</p>
        <p>Our team will be notified when your part is done. We will enter your tenant and finish the integration setup for you.</p>
    </div>

    <v-checkbox
        label="eCELLAR"  
        :value="isIntegrationOn('ecellar')" 
        v-on:change="setIntegration($event, 'ecellar')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('ecellar')"
    >
        <p>eCELLAR charges a one-time fee to complete this integration, and a monthly fee while it's in use. Please contact eCELLAR for exact fee details if you're interested in this integration.</p>

        <p>If you would like to proceed, check the box below and we'll request the integration from eCELLAR.</p>

        <v-checkbox
            label="I understand eCELLAR's fees and would like to proceed with this integration."
            v-model="setup_data.accept_ecellar_fee"
            v-on:change="doUpdate"
            style="margin-bottom: -25px"
        />
    </div>

    <v-checkbox
        label="Klaviyo"  
        :value="isIntegrationOn('klaviyo')" 
        v-on:change="setIntegration($event, 'klaviyo')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('klaviyo')"
    >
        <p>Thanks for letting us know! Our team will help you with this integration after your launch. </p>
    </div>

    <v-checkbox
        label="Mailchimp"  
        :value="isIntegrationOn('mailchimp')" 
        v-on:change="setIntegration($event, 'mailchimp')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('mailchimp')"
    >
        <p>Thanks for letting us know! Our team will help you with this integration after your launch. </p>
    </div>


    <v-checkbox
        label="Offset"  
        :value="isIntegrationOn('offset')" 
        v-on:change="setIntegration($event, 'offset')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('offset')"
    >
        <p>To connect Offset and RedChirp, email <a href="mailto:support@offsetpartners.com">support@offsetpartners.com</a> to request your RedChirp integration turned on.</p>
    </div>


    <v-checkbox
        label="OrderPort"  
        :value="isIntegrationOn('order-port')" 
        v-on:change="setIntegration($event, 'order-port')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('order-port')"
    >
        <p>As of January 1, 2025, OrderPort began charging $50 per month for wineries using the OrderPort &lt;&gt; RedChirp integration. However, if your winery signed up for OrderPort between June 18, 2024, and December 31, 2024 &mdash; when the integration was free &mdash; OrderPort will waive this fee.</p>
        <p>To activate your RedChirp integration, email <a href="mailto:traci@orderport.net">Traci@orderport.net</a> and copy <a href="mailto:help@redchirp.com">help@redchirp.com</a>, letting OrderPort know you'd like it turned on. They'll take care of the rest.</p>

    </div>

    <v-checkbox
        label="Outshinery"  
        :value="isIntegrationOn('outshinery')" 
        v-on:change="setIntegration($event, 'outshinery')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('outshinery')"
    >
        <p>Thanks for letting us know! We'll work with Outshinery to get this set up for you.</p>
    </div>

    <v-checkbox
        label="ShipCompliant"  
        :value="isIntegrationOn('ship-compliant')" 
        v-on:change="setIntegration($event, 'ship-compliant')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('ship-compliant')"
    >
        <p style="margin-top: 15px">Turn on the RedChirp &lt;&gt; Savos ShipCompliant integration in 3 easy steps:</p>
        <ul>
            <li>Create a web service account in Sovos ShipCompliant</li>
            <li>Turn on the ShipCompliant integration in RedChirp</li>
            <li>Let us know so we can confirm everything for you.</li>
        </ul>
        <p style="margin-top: 15px">You can find thorough instructions <a target="_blank" href="https://redchirp.com/redchirp-integration-shipcompliant/">here.</a></p>
    </div>

    <v-checkbox
        label="ShipEngine"  
        :value="isIntegrationOn('ship-engine')" 
        v-on:change="setIntegration($event, 'ship-engine')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('ship-engine')"
    >
        <p style="margin-top: 15px">Thanks for letting us know! Our team will help you with this integration after your launch.</p>
    </div>

     <v-checkbox
        label="tock"  
        :value="isIntegrationOn('tock')" 
        v-on:change="setIntegration($event, 'tock')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('tock')"
    >
        <ul>
            <li>To connect to Tock, have your Tock Account Owner send an email to <a href="mailto:integrate@tockhq.com">integrate@tockhq.com</a> requesting that RedChirp be granted API access to your Tock account(s).</li>
        </ul>

    </div>

    <v-checkbox
        label="VinesOS"  
        :value="isIntegrationOn('vines-os')" 
        v-on:change="setIntegration($event, 'vines-os')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('vines-os')"
    >
        <p>Email <a href="mailto:support@VinesOS.com">support@VinesOS.com</a>, and copy <a href="mailto:help@RedChirp.com">help@RedChirp.com</a>, to let VinesOS know that you would like your RedChirp integration turned on. VinesOS will handle the rest.</p>
        <p>Please note: VinesOS charges a one-time $100 fee to set up the RedChirp integration for those on their Starter plan; they do not charge any fees to set up the RedChirp integration for those on their Standard or higher plans.</p>
    </div>

    <v-checkbox
        label="VinSuite"  
        :value="isIntegrationOn('vinsuite')" 
        v-on:change="setIntegration($event, 'vinsuite')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('vinsuite')"
    >
        <p>Thanks for letting us know! We'll work with VinSuite to get this set up for you.</p>
        
    </div>

    <v-checkbox
        label="WineDirect (Classic)"  
        :value="isIntegrationOn('winedirect')" 
        v-on:change="setIntegration($event, 'winedirect')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('winedirect')"
    >
        <p>To connect WineDirect and RedChirp, follow these <a href="https://redchirp.com/how-to-connect-redchirp-and-winedirect/" target="_blank">quick 2-step instructions</a>.</p>
        <p>Our team will be notified when your part is done and will be happy to complete your integration for you.</p>
    </div>

    <v-checkbox
        label="WineDirect (All New / BigCommerce)"  
        :value="isIntegrationOn('winedirect-big-commerce')" 
        v-on:change="setIntegration($event, 'winedirect-big-commerce')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('winedirect-big-commerce')"
    >
       <p>Thanks for letting us know! Our team will help you with this integration after your launch.</p>
    </div>

    <v-checkbox
        label="WineDirect Fulfillment"  
        :value="isIntegrationOn('wine-direct-fulfillment')" 
        v-on:change="setIntegration($event, 'wine-direct-fulfillment')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('wine-direct-fulfillment')"
    >
        <p>Tell your customer service contact at WineDirect Fulfillment that you would like your RedChirp integration turned on.</p>
    </div>

    <v-checkbox
        label="Wineshipping"  
        :value="isIntegrationOn('wine-shipping')" 
        v-on:change="setIntegration($event, 'wine-shipping')"
        style="margin-bottom: -25px"
    />

    <div
        class="instructions"
        v-if="isIntegrationOn('wine-shipping')"
    >
        <p>To connect Wineshipping and RedChirp, tell your customer service contact at Wineshipping that you would like your RedChirp integration turned on.</p>
    </div>

    <v-switch
        label="This section is complete"
        v-model="setup_data.complete"
        v-on:change="doUpdate"
        v-if="!provision"
    />

    <v-switch
        label="This section is complete (does not affect the welcome screen)"
        v-model="profile.provision_info.complete_integrations"
        v-on:change="doUpdate"
        v-if="provision"
    />
   
</div>
</template>

<script>

const _ = require('lodash');

export default 
{
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },

        provision: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            setup_data: {},
        }
    },

    mounted () {
        this.setup_data = _.cloneDeep(this.profile.integration_settings);
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            if ( this.provision )
            {
                this.setup_data.provision_complete = this.profile.provision_info.complete_integrations;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/integration-settings',
            
                'params' : this.setup_data,
            
                'on_success': (data) => {
                       
                        this.$emit('reload');
                        
                    },
            
                'on_error': 'Unable to save integration settings',
            });
        },

        isIntegrationOn(content_type)
        {
            if ( this.setup_data == null ) return false;
            if ( this.setup_data.content_types == null ) return false;

            return this.setup_data.content_types.includes(content_type);
        },

        setIntegration(value, content_type)
        {
            this.setup_data.content_types = this.setup_data.content_types.filter((el) => { return el != content_type; });

            if ( value == true )
            {
                this.setup_data.content_types.push(content_type); 
            }

            this.doUpdate();
        },
    },
}
</script>

<style lang="scss" scoped>
.instructions
{
    margin-left: 20px; 
    margin-top: 15px; 
    background-color: rgba(0,0,0,0.05); 
    padding: 15px; 
    padding-left: 30px; 
    border-radius: 15px;
}

</style>

